// fund_setup RETIRED (Ale ruling 2026-07-24, mig 141): the fund/root-entity
// conflict now rides the standard possible_match resolution question on the
// pending confirm_chain_head proposal — no bespoke task, no pane.
const MANAGER_RESOLVE_TYPES = [
  'look_through_review',
  'verification_signoff',
  'verification_remediation',
]

const CLOSE_TYPES = ['daily_digest']

export { CLOSE_TYPES, MANAGER_RESOLVE_TYPES }
export const RESOLVE_PANE_TASK_TYPES = [...MANAGER_RESOLVE_TYPES, ...CLOSE_TYPES]
